import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { deliveryItems } from '../data/content';
export function Delivery() {
  return <section className="border-b border-line bg-night px-4 py-14 sm:px-6 sm:py-20" data-id="element-87" data-mp="vi6uny6of4eo">
      <SectionHeading eyebrow="Livraison immédiate" title="Que recevrez-vous immédiatement après votre achat ?" subtitle="Dès la première minute, vous disposerez d’un système complet d’aide à la décision clinique, prêt pour votre prochaine consultation." data-id="element-88" data-mp="vk05lpoboash" />

      <ul className="mx-auto mt-10 flex w-full max-w-3xl flex-col gap-4" data-id="element-89" data-mp="1j9ugw2sztram">
        {deliveryItems.map(item => <li key={item.title} className="flex gap-4 rounded-2xl border border-line bg-surface p-5 sm:p-6" data-id="element-90" data-mp="19hy7hvlgier3">
            <span className="text-2xl leading-none" aria-hidden="true" data-id="element-91" data-mp="26ydoeg47y01n">
              {item.emoji}
            </span>
            <div className="min-w-0" data-id="element-92" data-mp="2252iqib57pbb">
              <h3 className="font-display text-lg font-bold leading-snug text-white sm:text-xl" data-id="element-93" data-mp="xvfefwbkt1ih">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-slate-400" data-id="element-94" data-mp="12t76qrg4upn7">{item.body}</p>
            </div>
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-white" data-id="element-95" data-mp="o3rs29tvmanv">
        Tout patient rénal qui entre dans votre cabinet disposera d’une route clinique claire avant
        la fin de la consultation.
      </p>

      <div className="mx-auto mt-8 max-w-xl" data-id="element-96" data-mp="j7avqsciwpzp">
        <CTAButton label="Je veux mon système de décision" caption="Algorithmes, protocoles, routes et checklists réunis au même endroit" data-id="element-97" data-mp="56qbdrqymm43" />
      </div>
    </section>;
}